// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.delete[data-v-1e365a87]{\n  display: inline-block;\n  float: right;\n  cursor: pointer;\n}\n.main[data-v-1e365a87] {\n  background: white;\n  border: 1px solid lightgray;\n  border-radius: 5px;\n  min-height: 3em;\n}\n.wrong[data-v-1e365a87]\n{\n  border: 2px solid darkred;\n}\nul[data-v-1e365a87] \n{\n  margin: 0em;\n}\n", ""]);
// Exports
module.exports = exports;
